var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContentBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 722.89 645.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fbc2af;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Errorscreen"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m0,46.37c13.32,20.56,36.8,33.36,51.84,53.82,19.93,27.12,36.43,58.61,43.49,91.64,11.48,53.79,12.48,113.93,46.27,160.62,53.86,74.42,148.18,78.37,218.42,125.17,70.71,47.12,75.31,162.5,174.7,167.5,101.42,5.1,170.61-121.23,184.42-207.85,10.29-64.53.61-111.65-43.77-157.83-53.9-56.09-111.96-100.66-181.11-137.08C389.21,87.05,272.47,34.49,156.22,7.88,124.96.72,9.12-17.2,0,46.37Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentBubble);
export default __webpack_public_path__ + "static/media/contentBubble.b1972d0593b684784210bf99ea79453b.svg";
export { ForwardRef as ReactComponent };